export default __webpack_public_path__ + "static/media/exam.e77450a6.png";